<template>
    <div class="flex h-fit w-fit">
        <vds-media
            paused
            waiting
            seeking
            can-play
            muted
            class="flex"
        >
            <vds-audio class="">
                <audio
                    :src="audioUrl"
                    preload="auto"
                    class="hidden"
                ></audio>
            </vds-audio>
            <div class="flex items-center gap-2">
                <vds-play-button>
                    <!-- Pause Icon. -->
                    <div class="media-paused:hidden flex">
                        <svg
                            width="12"
                            height="14"
                            viewBox="0 0 12 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4"
                        >
                            <path
                                d="M0.235596 13.3413H3.83071V0.563477H0.235596V13.3413ZM7.42582 0.563477V13.3413H11.0209V0.563477H7.42582Z"
                                fill="#999999"
                            />
                        </svg>
                    </div>
                    <!-- Play Icon. -->
                    <div class="media-paused:flex hidden">
                        <svg
                            width="10"
                            height="13"
                            viewBox="0 0 10 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4"
                        >
                            <path
                                d="M0.000152588 0.375V12.625L9.62515 6.5L0.000152588 0.375Z"
                                fill="#999999"
                            />
                        </svg>
                    </div>
                </vds-play-button>
                <vds-time
                    type="current"
                    class="text-sm"
                ></vds-time>
                <vds-time-slider
                    min="0"
                    max="100"
                    value="50"
                    step="0.01"
                    class="w-24"
                >
                    <div class="slider-track"></div>
                    <div class="slider-track fill"></div>
                    <div class="slider-thumb-container">
                        <div class="slider-thumb"></div>
                    </div>
                </vds-time-slider>
                <div class="flex items-center gap-1">
                    <vds-mute-button muted>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="media-muted:hidden flex"
                        >
                            <path
                                d="M3 10V14C3 14.55 3.45 15 4 15H7L10.29 18.29C10.92 18.92 12 18.47 12 17.58V6.41C12 5.52 10.92 5.07 10.29 5.7L7 9H4C3.45 9 3 9.45 3 10ZM16.5 12C16.5 10.23 15.48 8.71 14 7.97V16.02C15.48 15.29 16.5 13.77 16.5 12ZM14 4.45V4.65C14 5.03 14.25 5.36 14.6 5.5C17.18 6.53 19 9.06 19 12C19 14.94 17.18 17.47 14.6 18.5C14.24 18.64 14 18.97 14 19.35V19.55C14 20.18 14.63 20.62 15.21 20.4C18.6 19.11 21 15.84 21 12C21 8.16 18.6 4.89 15.21 3.6C14.63 3.37 14 3.82 14 4.45V4.45Z"
                                fill="#999999"
                            />
                        </svg>

                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="media-muted:flex hidden"
                        >
                            <path
                                d="M19.1 21.9L16.775 19.575C16.5416 19.7083 16.3083 19.8373 16.075 19.962C15.8416 20.0873 15.6 20.2 15.35 20.3C15.0166 20.4333 14.7083 20.3917 14.425 20.175C14.1416 19.9583 14 19.6583 14 19.275C14 19.0917 14.0543 18.9293 14.163 18.788C14.271 18.646 14.4083 18.5417 14.575 18.475C14.7083 18.425 14.8376 18.3707 14.963 18.312C15.0876 18.254 15.2083 18.1917 15.325 18.125L12 14.8V17.575C12 18.025 11.7956 18.3373 11.387 18.512C10.979 18.6873 10.6166 18.6167 10.3 18.3L6.99995 15H3.99995C3.71662 15 3.47928 14.904 3.28795 14.712C3.09595 14.5207 2.99995 14.2833 2.99995 14V10C2.99995 9.71667 3.09595 9.479 3.28795 9.287C3.47928 9.09566 3.71662 9 3.99995 9H6.19995L2.09995 4.9C1.91662 4.71667 1.82495 4.48333 1.82495 4.2C1.82495 3.91667 1.91662 3.68333 2.09995 3.5C2.28328 3.31667 2.51662 3.225 2.79995 3.225C3.08328 3.225 3.31662 3.31667 3.49995 3.5L20.5 20.5C20.6833 20.6833 20.775 20.9167 20.775 21.2C20.775 21.4833 20.6833 21.7167 20.5 21.9C20.3166 22.0833 20.0833 22.175 19.7999 22.175C19.5166 22.175 19.2833 22.0833 19.1 21.9ZM15.35 3.65C17.05 4.33333 18.4166 5.425 19.45 6.925C20.4833 8.425 21 10.1083 21 11.975C21 12.8583 20.8793 13.7083 20.638 14.525C20.396 15.3417 20.05 16.1 19.6 16.8L18.15 15.35C18.4333 14.8333 18.646 14.2917 18.788 13.725C18.9293 13.1583 19 12.575 19 11.975C19 10.5083 18.596 9.19166 17.788 8.025C16.9793 6.85833 15.9083 6.00833 14.575 5.475C14.3916 5.40833 14.25 5.3 14.15 5.15C14.05 5 14 4.83333 14 4.65C14 4.28333 14.1416 3.99167 14.425 3.775C14.7083 3.55833 15.0166 3.51667 15.35 3.65ZM16.25 13.45L14 11.2V7.95C14.7833 8.31667 15.396 8.86667 15.838 9.6C16.2793 10.3333 16.5 11.1333 16.5 12C16.5 12.25 16.4793 12.496 16.438 12.738C16.396 12.9793 16.3333 13.2167 16.25 13.45ZM12 9.2L9.39995 6.6L10.3 5.7C10.6166 5.38333 10.979 5.31233 11.387 5.487C11.7956 5.66233 12 5.975 12 6.425V9.2Z"
                                fill="#999999"
                            />
                        </svg>
                    </vds-mute-button>
                    <vds-volume-slider
                        min="0"
                        max="200"
                        value="50"
                        step="1"
                        class="w-14"
                    >
                        <div class="slider-track"></div>
                        <div class="slider-track fill"></div>
                        <div class="slider-thumb-container">
                            <div class="slider-thumb"></div>
                        </div>
                    </vds-volume-slider>
                </div>
            </div>
        </vds-media>
    </div>
</template>
<script setup>
import '@vidstack/player/define/vds-media.js';
import '@vidstack/player/define/vds-audio.js';
import '@vidstack/player/define/vds-play-button.js';
import '@vidstack/player/define/vds-time.js';
import '@vidstack/player/define/vds-time-slider.js';
import '@vidstack/player/define/vds-volume-slider.js';
import '@vidstack/player/define/vds-mute-button.js';

defineProps({
    audioUrl: {
        type: String,
        required: true,
    },
});
</script>
<style>
@reference "#tailwind.css";

/* Avoid double controls on iOS when in fullscreen. */
vds-media[hide-ui] .media-controls,
/* Hide controls if media is not ready for playback, or user is idle. */
vds-media[user-idle] .media-controls,
vds-media:not([can-play]) .media-controls {
    opacity: 0;
    visibility: hidden;
}
vds-media {
    margin: 0px;
    padding: 0;
}
vds-time-slider {
    --height: 12px;
    --thumb-width: 12px;
    --track-height: 4px;
    @apply rounded-full;
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    height: var(--height);
    /** Prevent thumb flowing out of slider. */
    margin: 0 calc(var(--thumb-width) / 2);
    cursor: pointer;
}

vds-volume-slider {
    --height: 12px;
    --thumb-width: 12px;
    --track-height: 4px;
    @apply rounded-full;
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    height: var(--height);
    /** Prevent thumb flowing out of slider. */
    margin: 0 calc(var(--thumb-width) / 2);
    cursor: pointer;
}

.slider-track {
    @apply bg-muval-gray-4 rounded-full;
    width: 100%;
    height: var(--track-height);
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 0;
    transform: translateY(-50%);
}

.slider-track.fill {
    @apply bg-muval-sky-1 rounded-full;
    transform-origin: left center;
    transform: translateY(-50%) scaleX(var(--vds-fill-rate));
    will-change: transform;
    z-index: 1; /** above track. */
}

.slider-thumb-container {
    position: absolute;
    top: 0;
    left: var(--vds-fill-percent);
    width: var(--thumb-width);
    height: 100%;
    transform: translateX(-50%); /** re-center along x-axis. */
    z-index: 2; /** above track fill. */
    will-change: left;
}

[dragging] .slider-thumb-container {
    left: var(--vds-pointer-percent);
}

.slider-thumb {
    position: absolute;
    top: 50%;
    left: 0;
    width: var(--thumb-width);
    height: var(--thumb-width);
    @apply bg-muval-sky-1 rounded-full;
    transform: translateY(-50%);
}
</style>
